import { useState } from "react";
import { motion } from "framer-motion";
import { Send, Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/siteData";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Packages", href: "#packages" },
  { label: "Films", href: "#films" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0B132B]/80 border-b border-teal-500/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2" data-testid="navbar-logo">
          <Send className="w-6 h-6 text-teal-400 -rotate-12" strokeWidth={2.2} />
          <span className="font-serif text-2xl tracking-tight">
            <span className="text-white font-semibold">DX</span>
            <span className="text-teal-400 font-medium">HOLIDAYS</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-slate-300 hover:text-teal-300 transition-colors duration-300 relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-teal-400 hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            data-testid="nav-call-button"
            className="flex items-center gap-2 rounded-full border border-teal-400/40 px-5 py-2 text-sm text-teal-300 hover:bg-teal-400 hover:text-[#0B132B] transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>
        </nav>

        <button
          className="md:hidden text-slate-200"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0B132B]/95 backdrop-blur-xl border-t border-teal-500/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="text-base text-slate-200 hover:text-teal-300 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            data-testid="nav-mobile-call-button"
            className="flex items-center gap-2 text-teal-300"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phone}
          </a>
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
